export default {
  'processes.title': 'Processes',
  'processes.start.title': 'Start Request',
  'processes.tab.groups': 'Groups',
  'processes.tab.favorites': 'Favorites',
  'processes.tab.list': 'Processes',
  'processes.form.processGroup': 'Process Group',
  'processes.form.startMode': 'Start Mode',
  'processes.form.instancesNamePattern': 'Request Name Pattern',
  'processes.form.lastGeneratedNumber': 'Last Generated Number',
  'processes.form.isPublicProcess': 'Public?',
  'processes.form.isNotificationsEnabled': 'Notifications Enabled?',
  'processes.form.notificationsFrequency': 'Notifications Frequency',
  'processes.form.notificationsFrequencyValue': 'Notifications Frequency Value',
  'processes.form.startFrequency': 'Start Frequency',
  'processes.form.startFrequencyValue': 'Start Frequency Value',
  'processes.form.startDate': 'Start Date',
  'processes.form.lastStartDate': 'Last Start Date',
  'processes.form.isDeadlineEnabled': 'Enable Execution Time Limit Control?',
  'processes.form.deadlineMeasureUnit': 'Time Control Unit',
  'processes.form.deadlineMeasureValue': 'Time Control Value',

  'processes.form.isRequestsLimitEnabled': 'Control Allowed Number of Requests?',
  'processes.form.requestsLimit': 'Allowed Number of Requests',
  'processes.form.maxRejectionCount': 'Maximum Rejection Count',
  'processes.form.automaticNumbersCurrentYear': 'Automatic Numbers Current Year',
  'processes.form.automaticNumbersCurrentMonth': 'Automatic Numbers Current Month',
  'processes.form.automaticNumbersCurrentDay': 'Automatic Numbers Current Day',
  'processes.form.disableSendApprovedRequestMailAtEnd': 'Disable Send Approved Request Mail at End',
  'processes.form.disableSendRejectedRequestMailAtEnd': 'Disable Send Rejected Request Mail at End',
  'processes.form.isSendErrorNotificationsEnabled': 'Enable Error Notifications?',
  'processes.form.isBulkRequestCreationEnabled': 'Enable Bulk Request Creation?',
  'processes.form.isAllowViewWithoutAuthenticatingEnabled': 'Allow View Without Authentication?',
  'processes.form.isAllowApprovalWithoutAuthenticatingEnabled':
    'Allow Approval Without Authentication?',
  'processes.form.disableRequestCancellation': 'Disable Request Cancellation',
  'processes.form.commentsAccessMode': 'Comments Access Mode',
  'processes.form.commentsAccessMode.disabled': 'Disabled',
  'processes.form.commentsAccessMode.readOnly': 'Read-only',
  'processes.form.commentsAccessMode.appendOnly': 'Append-only (no edit or delete)',
  'processes.form.commentsAccessMode.delete': 'Delete-only (moderation)',
  'processes.form.commentsAccessMode.edit': 'Edit (no delete)',
  'processes.form.commentsAccessMode.editAndDelete': 'Edit and delete',
  'processes.form.isShowPercentEnabled': 'Show Progress Percentage?',
  'processes.form.percentActionFilters': '% / Action Types',
  'processes.form.offlineEnabled': 'Enable Offline Mode',

  // Wizard Steps
  'processes.wizard.steps.basicInformation': 'Basic Information',
  'processes.wizard.steps.namePatterns': 'Name Patterns',
  'processes.wizard.steps.notificationSettings': 'Notification Settings',
  'processes.wizard.steps.startMode': 'Start Mode',
  'processes.wizard.steps.requestsLimitDeadline': 'Requests Limit & Deadline',
  'processes.wizard.steps.others': 'Other Settings',

  'processes.select.instant': 'Manual Flow',
  'processes.select.automated': 'Automated Flow',
  'processes.select.scheduled': 'Scheduled Flow',

  'processes.configure.title': 'Configure Process',
  'process.SearchInput.placeholder': 'Search Configuration',

  'process.text.fileName': 'Name',
  'process.text.userCreator': 'Author',
  'process.text.contentType': 'File Type',
  'process.text.options': 'Options',
  'process.text.processGroups': 'Process Groups',
  'process.text.processPortal': 'Process Portal',
  'process.text.completed': 'Completed',
  'process.text.manually': 'Manual',
  'process.text.automatic': 'Automatic',
  'process.text.schedule': 'Scheduled',

  'process.text.reportName': 'Name',
  'process.text.reportType': 'Type',
  'process.text.listName': 'Name',
  'process.text.listType': 'Type',
  'process.text.portalName': 'Name',
  'process.text.portalCode': 'Code',

  'process.button.bulk.upload': 'Upload Excel Format Requests',
  'process.button.bulk.label': 'Click to upload',

  'process.text.bulk.download': 'Download bulk upload template',
  'process.text.bulk.upload': 'Bulk upload requests',
  'process.text.bulk.isScheduledProcessingEnabled': 'Enable Scheduled Processing Date?',
  'process.text.bulk.attachments': 'Excel Document',
  'process.text.bulk.scheduledProcessingDate': 'Scheduled Processing Date',
  'process.text.bulk.download.loading': 'Downloading Requests Template file...',
  'process.text.bulk.download.success': 'Successfully downloaded the template file.',

  'process.text.reports.reportType1': 'Administration',
  'process.text.reports.reportType2': 'Process',
  'process.text.reports.reportType3': 'Request',
  'process.text.reports.reportType4': 'Generic',
  'process.text.reports.reportType5': 'PowerBIConnector',

  'process.text.lists.listType1': 'List',
  'process.text.lists.listType2': 'Gant',
  'process.text.lists.listType3': 'Calendar',
  'process.text.lists.listType4': 'Task',
  'process.text.lists.listType6': 'Cards',
  'process.text.lists.listType7': 'Map',
  'process.canvas.note.placeholder': 'Like a note...',
  'process.approval.card.general.description': 'General approval configuration',
  'process.approval.card.rejection.description': 'Rejection settings and rejection control',
  'process.approval.card.deadline.description': 'Execution time limit control',
  'process.approval.card.filters.general.description': 'General approver filters configuration',
  'process.approval.card.filters.users.description': 'Filter approvers by specific users',
  'process.approval.card.filters.positions.description': 'Filter approvers by positions',
  'process.approval.card.filters.areas.description': 'Filter approvers by areas',
  'process.approval.card.filters.userGroups.description': 'Filter approvers by user groups',
  'process.approval.card.filters.externalUsers.description': 'Filter approvers by external users',
  'process.approval.card.filters.agents.description': 'Filter approvers by AI agents',
  'process.approval.card.filters.userExtraFields.description':
    'Filter approvers by user extra fields',
  'process.approval.card.filters.global.description':
    'Configure global approver filters (7 sub-groups)',
  'process.approval.card.filters.formField.description':
    'Filter approvers by form fields (4 sub-groups)',
  'process.approval.filters.externalUsers.alert.title': 'Simplified Configuration',
  'process.approval.filters.externalUsers.alert.description':
    'This is a simplified version that handles a single external user filter. For full management of multiple items, use the list + drawer implementation.',
  'process.approval.filters.userExtraFields.alert.title': 'Simplified Configuration',
  'process.approval.filters.userExtraFields.alert.description':
    'This is a simplified version that handles a single extra user field filter. For full management of multiple items, use the list + drawer implementation.',

  'process.v1ConfigURL.noURL': 'No configuration URL provided',

  // Form List
  'form.title': 'Form List',
  'config.searchForm': 'Search form',

  // Form Canvas
  'config.form.canvas.creation': 'Form Creation',
  'config.form.canvas.configuration': 'Configuration',
  'config.form.canvas.preview': 'Preview',
  'config.form.canvas.confirm': 'Confirm',
  'config.form.canvas.searchComponent': 'Search a component',

  // Palette sections
  'config.form.canvas.section.layout': 'Layout',
  'config.form.canvas.section.text': 'Text',
  'config.form.canvas.section.numbers': 'Numbers',
  'config.form.canvas.section.datetime': 'Date & Time',
  'config.form.canvas.section.selection': 'Selection',
  'config.form.canvas.section.files': 'Files & Media',
  'config.form.canvas.section.people': 'People',
  'config.form.canvas.section.data': 'Data Sources',
  'config.form.canvas.section.advanced': 'Advanced',

  // Layout
  'config.form.canvas.component.group': 'Section',
  'config.form.canvas.component.divider': 'Divider',

  // Text
  'config.form.canvas.component.text': 'Short Text',
  'config.form.canvas.component.textMultiple': 'Long Text',
  'config.form.canvas.component.email': 'Email',
  'config.form.canvas.component.url': 'URL',
  'config.form.canvas.component.password': 'Password',

  // Numbers
  'config.form.canvas.component.integer': 'Integer',
  'config.form.canvas.component.decimal': 'Decimal',
  'config.form.canvas.component.slider': 'Slider',

  // Date & Time
  'config.form.canvas.component.date': 'Date',
  'config.form.canvas.component.dateTime': 'Date & Time',
  'config.form.canvas.component.time': 'Time',

  // Selection
  'config.form.canvas.component.choice': 'Dropdown',
  'config.form.canvas.component.radioGroup': 'Radio Group',
  'config.form.canvas.component.checkGroup': 'Check Group',
  'config.form.canvas.component.boolean': 'Toggle / Switch',

  // Files & Media
  'config.form.canvas.component.attachment': 'Attachment',
  'config.form.canvas.component.image': 'Image',
  'config.form.canvas.component.photo': 'Photo',
  'config.form.canvas.component.signature': 'Signature',

  // People
  'config.form.canvas.component.selectorUser': 'User',
  'config.form.canvas.component.selectorPosition': 'Position',
  'config.form.canvas.component.selectorUserGroup': 'User Group',
  'config.form.canvas.component.selectorArea': 'Area',

  // Data Sources
  'config.form.canvas.component.dbRemoteSearch': 'DB Search',
  'config.form.canvas.component.dbRemoteList': 'DB List',
  'config.form.canvas.component.wsRemoteSearch': 'WS Search',
  'config.form.canvas.component.wsRemoteList': 'WS List',
  'config.form.canvas.component.entityList': 'Entity List',
  'config.form.canvas.component.entitySearch': 'Entity Search',

  // Advanced
  'config.form.canvas.component.table': 'Table',
  'config.form.canvas.component.formula': 'Formula',
  'config.form.canvas.component.autoCalc': 'Auto Calc',
  'config.form.canvas.component.goToAction': 'Go To Action',
  'config.form.canvas.component.location': 'Location',
  'config.form.canvas.component.likert': 'Likert Scale',

  // Canvas drop labels
  'config.form.canvas.dropGroup': 'Drop here to add a section',
  'config.form.canvas.dropElement': 'Drop here to add an element',

  // Form Configuration Layout
  'config.form.config.addField': 'Add Field',
  'config.form.config.dropField': 'Drop here to add field',
  'config.form.config.unnamedSection': 'Untitled Section',
  'config.form.config.groupLabel': 'Group',
  'config.form.config.delete': 'Delete',
  'config.form.config.expand': 'Expand',
  'config.form.config.contract': 'Contract',
  'config.form.config.edit': 'Edit',
  'config.form.config.fieldPlaceholder': 'Enter a value',
  'config.form.config.header.label': 'Header',
  'config.form.config.uploadDragText': 'Drag and drop a file here or click',
  'config.form.config.drawer.field.title': 'Field Configuration',
  'config.form.config.drawer.section.title': 'Section Configuration',
  'config.form.config.drawer.general': 'General',
  'config.form.config.drawer.behavior': 'Behavior',
  'config.form.config.drawer.displayText': 'Field Label',
  'config.form.config.drawer.helpText': 'Help Text',
  'config.form.config.drawer.required': 'Required?',
  'config.form.config.drawer.enabled': 'Enabled Element?',
  'config.form.config.drawer.readOnly': 'Read-only?',
  'config.form.config.drawer.hidden': 'Hidden?',
  'config.form.config.drawer.sectionTitle': 'Section Title',
  'config.form.config.drawer.sectionDescription': 'Section Description',
  'config.form.config.drawer.internalName': 'Internal Name',

  // Drawer — field settings section
  'config.form.config.drawer.settings': 'Field Settings',
  'config.form.config.drawer.defaultValue': 'Default Value',
  'config.form.config.drawer.formula': 'Formula',
  'config.form.config.drawer.choices': 'Options (one per line)',
  'config.form.config.drawer.minLength': 'Min Length',
  'config.form.config.drawer.maxLength': 'Max Length',
  'config.form.config.drawer.minValue': 'Min Value',
  'config.form.config.drawer.maxValue': 'Max Value',
  'config.form.config.drawer.decimalPlaces': 'Decimal Places',
  'config.form.config.drawer.format': 'Format',
  'config.form.config.drawer.allowMultiple': 'Allow Multiple',
  'config.form.config.drawer.autoSelect': 'Auto-select First',
  'config.form.config.drawer.allowInsertNewOption': 'Allow New Options',
  'config.form.config.drawer.scannerEnabled': 'Scanner Enabled',
  'config.form.config.drawer.currentDateDefault': 'Default to Current Date',
  'config.form.config.drawer.currentDateTimeDefault': 'Default to Current Date & Time',
  'config.form.config.drawer.currentTimeDefault': 'Default to Current Time',
  'config.form.config.drawer.maxFileSize': 'Max File Size (MB)',
  'config.form.config.drawer.minAttachments': 'Min Attachments',
  'config.form.config.drawer.maxAttachments': 'Max Attachments',
  'config.form.config.drawer.step': 'Step',
  'config.form.config.drawer.textFormat': 'Text Format',
  'config.form.config.drawer.textFormat.plainText': 'Plain Text',
  'config.form.config.drawer.textFormat.richText': 'Rich Text',
  'config.form.config.drawer.orderDirection': 'Sort Order',
  'config.form.config.drawer.orderDirection.ascending': 'Ascending',
  'config.form.config.drawer.orderDirection.descending': 'Descending',
  'config.form.config.drawer.groupingType': 'Grouping Type',
  'config.form.config.drawer.groupingType.none': 'None',
  'config.form.config.drawer.groupingType.value': 'By Value',
  'config.form.config.drawer.groupingType.displayText': 'By Display Text',
  'config.form.config.drawer.currentUser': 'Default Current User',
  'config.form.config.drawer.currentUserPosition': 'Default Current Position',
  'config.form.config.drawer.currentUserUserGroups': 'Default Current Groups',
  'config.form.config.drawer.currentUserArea': 'Default Current Area',
  'config.form.config.drawer.isCurrentUserLocationEnabled': 'Default Current Location',
  'config.form.config.drawer.mathOperation': 'Math Operation',
  'config.form.config.drawer.mathOperation.sum': 'Sum',
  'config.form.config.drawer.mathOperation.avg': 'Average',
  'config.form.config.drawer.mathOperation.count': 'Count',
  'config.form.config.drawer.mathOperation.min': 'Min',
  'config.form.config.drawer.mathOperation.max': 'Max',
  'config.form.config.drawer.observations': 'Notes / Observations',
  'config.form.config.drawer.visibleInDetails': 'Visible in Details',
  'config.form.config.drawer.columnWidth': 'Column Width',
  'config.form.config.drawer.order': 'Order',
  'config.form.config.columnWidth.extraSmall': 'Extra Small',
  'config.form.config.columnWidth.small': 'Small',
  'config.form.config.columnWidth.medium': 'Medium',
  'config.form.config.columnWidth.large': 'Large (Full Width)',

  // Form Config
  'config.form.tab.form': 'Form',
  'config.form.tab.formConfig': 'Configurations',
  'config.form.tab.formStyle': 'Styles',
  'config.form.tab.formPublicStyle': 'Public Form Style',
  'config.form.title': 'Title',
  'config.form.header.text': 'Description',
  'config.form.header.image': 'Header Image',
  'config.form.wizardOrientation': 'Wizard / Orientation',
  'config.form.wizardOrientation.horizontal': 'Horizontal',
  'config.form.wizardOrientation.vertical': 'Vertical',
  'config.form.wizardStepStyle': 'Wizard / Style',
  'config.form.wizardStepStyle.stepNumber': 'Step Number',
  'config.form.wizardStepStyle.progressBar': 'Progress Bar',
  'config.form.formSendRequestButtonText': 'Send Button Text',
  'config.form.visibleInDetails': 'Visible in Details View?',
  'config.form.externalViewEnabled': 'External View Enabled?',
  'config.form.externalViewDetailsTabVisible': 'External View / Details Tab Visible?',
  'config.form.externalViewGeneratedDocumentsTabVisible':
    'External View / Generated Documents Tab Visible?',
  'config.form.externalViewDocumentsTabVisible': 'External View / Documents Tab Visible?',
  'config.form.hideSaveButton': 'Hide Save Button?',
  'config.form.hideCancelButton': 'Hide Cancel Button?',
  'config.form.style.template': 'Template',
  'config.form.style.template.default': 'Default',
  'config.form.style.mainColor': 'Main Color',
  'config.form.style.logoUrl': 'Logo URL',
  'config.form.style.fontUrl': 'Font URL',
  'config.form.publicStyle.template': 'Template',
  'config.form.publicStyle.template.basic': 'Basic',
  'config.form.publicStyle.template.basicBanner': 'Basic with Banner',
  'config.form.publicStyle.mainColor': 'Main Color',
  'config.form.publicStyle.logoUrl': 'Logo URL',
  'config.form.publicStyle.fontUrl': 'Font URL',
};
